import i18n from '../../../../i18n';

export async function boxConsumableIndexUseCase(boxRepository) {
    const result = await boxRepository.box_consumables_index();

    const actions = [
        {
            name: i18n.t('boxes.edit'),
            icon: {
                color: 'accent',
                icon: 'edit'
            },
            link: 'boxes/edit/0',
            permission: "box.show"
        },
        {
            name: i18n.t('boxes.delete'),
            icon: {
                color: 'accent',
                icon: 'delete'
            },
            method: 'askDelete',
            permission: "box.delete"
        }
    ]

    for(var i = 0; i < result.data.data.length; i++) {
        result.data.data[i] = result.data.data[i].attributes;

        const entity = new boxRepository.model_consumable(result.data.data[i]);

        if (!entity.isValid()) {
            console.log(entity);
            throw new Error("box inválido");
        }

        result.data.data[i]['actions'] = JSON.parse(JSON.stringify(actions));
        result.data.data[i]['actions'][0].link = `boxes/edit/${result.data.data[i].consumable.id}`
        result.data.data[i].parameters = result.data.data[i].consumable.id;
    }

    return result;
}